<template>
  <vx-card>
    <vs-row>
      <h4 class="mb-5">Add Rate Plan Policy</h4>
    </vs-row>

    <vs-row vs-w="12">
      <vs-col vs-w="12" class="mb-3">
        <vs-input
          class="w-full"
          icon-pack="feather"
          icon="icon-box"
          icon-no-border
          label="Rate Plan Policy Name (*)"
          v-model="payload.name"
        />
        <span class="block text-sm mt-2 text-danger">{{
          errors.first("name")
        }}</span>
      </vs-col>

      <vs-col vs-w="12" class="mt-3">
        <div class="vx-col w-full" @click.prevent="storeData">
          <vs-button class="mr-3 mb-2">Submit</vs-button>
        </div>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
// Store Module
import moduleRatePlanPolicyManagement from "@/store/rate-plan-policy-management/moduleRatePlanPolicyManagement.js";

export default {
  name: "RatePlanPolicyAdd",

  metaInfo: {
    title: "Add Rate Plan Policy",
    titleTemplate: "%s - Vancy Net",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },

  data: () => ({
    payload: {
      name: ""
    }
  }),

  methods: {
    storeData() {
      const formData = new FormData();
      // set formData
      formData.set("name", this.payload.name);

      this.$store
        .dispatch("ratePlanPolicyManagement/storeRatePlanPolicy", formData)
        .then(({ data: res }) => {
          this.$vs.notify({
            title: "Successful",
            text: res.msg_status,
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success"
          });

          this.$router.push("/rate-plan-policies");
        })
        .catch(err => {
          this.$catchErrorResponse(err)
        });
    }
  },

  created() {
    if (!moduleRatePlanPolicyManagement.isRegistered) {
      this.$store.registerModule(
        "ratePlanPolicyManagement",
        moduleRatePlanPolicyManagement
      );
      moduleRatePlanPolicyManagement.isRegistered = true;
    }
  }
};
</script>

<style></style>
